import classNames from 'classnames';
import { useContext } from 'react';
import AuthContext from '../../../contexts/authContext';
import useDarkMode from '../../../hooks/useDarkMode';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Button from '../../../components/bootstrap/Button';

const PastasHeader = () => {
	const { userData, logout } = useContext(AuthContext);
	const { darkModeStatus } = useDarkMode();

	return (
		<Header>
			<HeaderLeft>
				<div
					className={classNames('fs-3 fw-bold', {
						'text-dark': !darkModeStatus,
					})}>
					Olá, {userData?.name || userData?.email || 'Usuário'}!
				</div>
			</HeaderLeft>
			<HeaderRight>
				<div className='d-flex align-items-center gap-2'>
					<span className='text-muted'>{userData?.email}</span>
					<Button
						color='danger'
						size='sm'
						icon='Logout'
						isLight
						onClick={logout}
						aria-label='Sair'>
						Sair
					</Button>
				</div>
			</HeaderRight>
		</Header>
	);
};

export default PastasHeader;
